export const name = "KEYS.KEYSET_TO_JSON";
export const summary = `Gets a JSON \`STRING\` representation of a keyset.`;
export const reference = `
## KEYS.KEYSET_TO_JSON

Gets a JSON \`STRING\` representation of a keyset.

\`\`\`
KEYS.KEYSET_TO_JSON(keyset)
\`\`\`

### Description

Returns a JSON \`STRING\` representation of the input\`keyset\`. The returned JSON \`STRING\` is compatible with the definition of the google.crypto.tink.Keysetprotocol buffer message. You can convert the JSON\`STRING\` representation back to\`BYTES\` using \`KEYS.KEYSET_FROM_JSON\`.


### Return Data Type

\`STRING\`


### Example

The following query returns a new \`'AEAD_AES_GCM_256'\` keyset as a JSON-formatted \`STRING\`.



\`\`\`
SELECT KEYS.KEYSET_TO_JSON(KEYS.NEW_KEYSET('AEAD_AES_GCM_256'));
\`\`\`

The result is a \`STRING\` like the following.



\`\`\`
{
  "key":[
      {
        "keyData":{
          "keyMaterialType":"SYMMETRIC",
          "typeUrl":"type.googleapis.com/google.crypto.tink.AesGcmKey",
          "value":"GiD80Z8kL6AP3iSNHhqseZGAIvq7TVQzClT7FQy8YwK3OQ=="
        },
        "keyId":3101427138,
        "outputPrefixType":"TINK",
        "status":"ENABLED"
      }
    ],
  "primaryKeyId":3101427138
}
\`\`\`


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/aead_encryption_functions
`;
